var map = {
	"./01-b&r.png": "f245",
	"./02-pku.png": "290f",
	"./03-thu.png": "97c1",
	"./04-xjtu-wneu-polimi.png": "4f72",
	"./05-yi.png": "e499",
	"./06-washu.png": "47c6",
	"./07-cnbm-win.png": "2224",
	"./08-sues-xd.png": "f3d7",
	"./09-shunya.png": "f794",
	"./10-montreal.png": "f74b",
	"./11-jia.png": "6ab5",
	"./12-istanbul.png": "43be",
	"./13-tubseu.png": "ce3f",
	"./14-xauat.png": "ce7c",
	"./15-sjtuiuc.png": "07fe",
	"./16-bjtu.png": "11ee",
	"./17-sie.png": "8dea",
	"./18-tju-tuda.png": "23ea",
	"./19-solar-offspring.png": "7dcb",
	"./20-scut-polito.png": "b06f",
	"./21-unnc-alpha.png": "a2a3",
	"./22-israel.png": "41f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78f0";